import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { useMutation } from '@tanstack/react-query';
import { TypedMutationConfig } from '@/lib/react-query';
import { TAgent } from '../types/agent.type';

/**
 *
 */
export const DeleteAgentValidationSchema = z.object({
  agentId: z.string().min(1),
});
export type TDeleteAgentValidation = z.infer<typeof DeleteAgentValidationSchema>;
export type TDeleteAgentPayload = TDeleteAgentValidation;
export type TDeleteAgentResponse = ApiResponse<TAgent>;

export const deleteAgent = (payload: TDeleteAgentPayload): Promise<TDeleteAgentResponse> => {
  const url = `/user/manage/${payload.agentId}`;

  return axiosInstance.delete(url);
};

/**
 *  Return query key for delete agent
 */
type TUseDeleteAgentMutationOptions = {
  mutationConfigOptions?: TypedMutationConfig<typeof deleteAgent, AxiosErrorCustom>;
};

export const useDeleteAgentMutation = ({ mutationConfigOptions }: TUseDeleteAgentMutationOptions) => {
  const { ...restConfigOptions } = mutationConfigOptions ?? {};

  return useMutation({
    mutationFn: deleteAgent,
    ...restConfigOptions,
  });
};
